<template>
  <article :id="'post-' + id">
  <!-- <v-row no-gutters> -->
    <!-- <v-col cols="12"> -->
      <v-card class="mb-2X d-flex align-center" :href="link" flat>
        <v-avatar size="96" class="ma-3 mb-6 d-none d-sm-flex d-md-none d-lg-flex">
          <v-img :src="thumbnail"></v-img>
        </v-avatar>
        <div>
          <!-- <v-img v-if="thumbnail" :src="thumbnail" class="mb-4" :aspect-ratio="16/9" cover></v-img> -->
          <v-card-title class="ch-post__title text--caslon font-weight-bold" v-html="title"></v-card-title>
          <v-card-subtitle class="ch-post__meta py-2">
            <span v-html="postedOn"></span>
            <span class="mx-1 grey--text text--lighten-2"> | </span>
            <span v-html="postedBy"></span>
          </v-card-subtitle>
          <v-card-text>
            <slot name="default"></slot>
          </v-card-text>
        </div>
      </v-card>
    <!-- </v-col> -->
  <!-- </v-row> -->
</article>
</template>

<script>
  export default {
    name: 'CategoryPost',

    props: {
      id: {
        type: Number,
        default: null
      },
      image: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      category: {
        type: Object,
        default: () => ({})
      },
      postedOn: {
        type: String,
        default: null
      },
      postedBy: {
        type: String,
        default: null
      },
      authorImage: {
        type: String,
        default: null
      },
      link: {
        type: String,
        default: null
      }
    },

    // props: ['id', 'image', 'title', 'category', 'posted-on', 'posted-by', 'author-image', 'link'],

    computed: {
      thumbnail() {
        return this.image ? this.image : this.authorImage
      }
    }
  }
</script>

<style lang="sass">
  .ch-post__title
    word-break: normal
    line-height: 1.85rem
  .ch-post__subtitle
    line-height: 1.5rem
  .ch-post__meta a
    text-decoration: none
</style>